import { render, staticRenderFns } from "./DebuggingPosturas.vue?vue&type=template&id=286bb362&scoped=true"
import script from "./DebuggingPosturas.vue?vue&type=script&lang=js"
export * from "./DebuggingPosturas.vue?vue&type=script&lang=js"
import style0 from "./DebuggingPosturas.vue?vue&type=style&index=0&id=286bb362&prod&lang=scss&scoped=true"
import style1 from "./DebuggingPosturas.vue?vue&type=style&index=1&id=286bb362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286bb362",
  null
  
)

export default component.exports